import { render, staticRenderFns } from "./RepassesAtrasados.vue?vue&type=template&id=0ed69852&"
import script from "./RepassesAtrasados.vue?vue&type=script&lang=js&"
export * from "./RepassesAtrasados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports